/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Channelaudience1Inputs */

const en_channelaudience1 = /** @type {(inputs: Channelaudience1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reaches ${i?.count} users`)
};

const de_channelaudience1 = /** @type {(inputs: Channelaudience1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreicht ${i?.count} Nutzer`)
};

/**
* | output |
* | --- |
* | "Reaches {count} users" |
*
* @param {Channelaudience1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelaudience1 = /** @type {((inputs: Channelaudience1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelaudience1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelaudience1(inputs)
	return de_channelaudience1(inputs)
});
export { channelaudience1 as "channelAudience" }